'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getBetssonContext = undefined;

var _utils = require('../lib/utils');

var getBetssonContext = exports.getBetssonContext = function getBetssonContext(_ref) {
  var playerSessionID = _ref.playerSessionID,
      Language = _ref.Language,
      Currency = _ref.Currency,
      Jurisdiction = _ref.Jurisdiction,
      UserAgent = _ref.UserAgent,
      CountryCode = _ref.CountryCode,
      Platform = _ref.Platform,
      IframeSetup = _ref.IframeSetup,
      DeepLinking = _ref.DeepLinking;

  if (playerSessionID) {
    return (0, _utils.postProtected)('/sportsbook/create-betsson-context', playerSessionID, {
      Language: Language,
      Currency: Currency,
      Jurisdiction: Jurisdiction,
      UserAgent: UserAgent,
      CountryCode: CountryCode,
      Platform: Platform,
      IframeSetup: IframeSetup,
      DeepLinking: DeepLinking
    });
  } else {
    return (0, _utils.post)('/sportsbook/create-betsson-context', {
      Language: Language,
      Currency: Currency,
      Jurisdiction: Jurisdiction,
      UserAgent: UserAgent,
      CountryCode: CountryCode,
      Platform: Platform,
      IframeSetup: IframeSetup,
      DeepLinking: DeepLinking
    });
  }
};

exports.default = {
  getBetssonContext: getBetssonContext
};